export default "__VITE_ASSET__VHKG1s_c__"